import { useQuery } from '@tanstack/react-query';

import { schedulesApi } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

/** One run; polls until it is done or failed. */
export function useScheduleRun(id: string, runId: string | null) {
  return useQuery({
    queryKey: scheduleKeys.run(id, runId ?? ''),
    queryFn: () => schedulesApi.run(id, runId ?? ''),
    enabled: runId !== null,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'queued' || status === 'running' ? 3_000 : false;
    },
  });
}
